import { render, staticRenderFns } from "./registerFormation.vue?vue&type=template&id=626e6a52"
import script from "./registerFormation.vue?vue&type=script&lang=js"
export * from "./registerFormation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports